import * as Types from '../constants/Types';

export const dataCustomerAction = (filters) => ({type: Types.CUSTOMER_LIST_ACTION, filters});
export const dataCustomerSuccess = (customers) => ({type: Types.CUSTOMER_LIST_SUCCESS, customers});

export const exportCustomerAction = (filters) => ({type: Types.CUSTOMER_EXPORT_ACTION, filters});
export const exportCustomerSuccess = (exCustomer) => ({type: Types.CUSTOMER_EXPORT_SUCCESS, exCustomer});

export const getCustomerAction = (params) => ({type: Types.CUSTOMER_GET_ITEM_ACTION, params});
export const getCustomerSuccess = (itemCustomer) => ({type: Types.CUSTOMER_GET_ITEM_SUCCESS, itemCustomer});

export const filterGetAllCustomerAction = (filters) => ({type: Types.CUSTOMER_FILTER_GET_ALL_ACTION, filters});
export const filterGetAllCustomerSuccess = (allCustomer) => ({type: Types.CUSTOMER_FILTER_GET_ALL_SUCCESS, allCustomer});

export const updateCustomerAction = (params) => ({type: Types.CUSTOMER_UPDATE_ACTION, params});